import { render, staticRenderFns } from "./EhrEvalFeedbackDialog.vue?vue&type=template&id=6b4083dc&lang=pug"
import script from "./EhrEvalFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./EhrEvalFeedbackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports